// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectCard__base--2Ef_6","icon":"SelectCard__icon--Fv3eO","button":"SelectCard__button--1Edxs","container":"SelectCard__container--OW1Hr"};